export default (state, action) => {
  return Object.assign({}, state, {
    data: Object.assign({}, state.data, {
      page_info: Object.assign({}, state.data.page_info, {
        page_size: action.size,
      }),
    }),
  });
};
